// @flow

import React, { Component, type ComponentType } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { fetchData } from '../../../helpers';
import { getUiSetting, setUiSetting } from '../../../store/uiStore';
import withActivePdbId from '../../withActivePdbId';
import withErrorBoundary from '../../withErrorBoundary';

type Occasions = {|
  total: number,
  link: string,
|};

type StateProps = {|
  occasions: ?Occasions | false,
|};

type DispatchProps = {|
  storeOccasions: Function,
|};

type OwnProps = {
  pdbId: string,
};

type OccasionsResponse = {|
  total: number,
  link: string,
|};

function withNumberOfOccasions<Props: {}>(
  WrappedComponent: ComponentType<Props>,
): ComponentType<Props> {
  class NumberOfOccasions extends Component<
    Props & OwnProps & StateProps & DispatchProps,
  > {
    componentDidMount = async () => {
      const { pdbId, storeOccasions } = this.props;
      if (!pdbId) {
        return;
      }

      const { json } = await fetchData({ endpoint: `/pdb/${pdbId}/occasions` });
      const occasions: OccasionsResponse = json;
      storeOccasions(occasions);
    }

    render() {
      const {
        occasions, storeOccasions, pdbId, ...restProps
      } = this.props;
      if (!occasions) {
        return <WrappedComponent {...restProps} />;
      }

      const { total, link } = occasions;
      return (
        <WrappedComponent
          {...restProps}
          numberOfOccasions={total}
          linkToOccassions={link}
        />
      );
    }
  }

  /**
   * @TODO i know the using the UI store seems a little hacky
   * In the future we should create a key value store (which the ui store uses)
   * So we have a more logical API :-)
   */
  const mapStateToProps = (state: any, { pdbId }: OwnProps): StateProps => ({
    occasions: getUiSetting(state, `occasions-${pdbId}`),
  });

  const mapDispatchProps = (dispatch: Function, { pdbId }: OwnProps): DispatchProps => ({
    storeOccasions: (occasions: OccasionsResponse) => dispatch(setUiSetting(`occasions-${pdbId}`, occasions)),
  });

  return withErrorBoundary(compose(
    withActivePdbId,
    connect(mapStateToProps, mapDispatchProps),
  )(NumberOfOccasions));
}


export default withNumberOfOccasions;
